// Where someone logged in starts (#442: the visitor's pages send them there, and so does logging in)
import { seesAdminScreens, isSuperadminOnly } from 'api/core/roles';
export var startRouteFor = function startRouteFor(user) {
  if (isSuperadminOnly(user)) return {
    name: 'adminMaintenance'
  };
  if (seesAdminScreens(user)) return {
    name: 'adminHome'
  };
  if (user.profile && user.profile.owner) return {
    name: 'ownerDashboard'
  };
  return {
    name: 'home2'
  };
};